"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Const;
(function (Const) {
    Const.accessTokenSubject = "access-token";
    Const.refreshTokenSubject = "refresh-token";
    Const.accessVerificationType = {
        deleteUser: "delete-user",
        signIn: "sign-in",
        signUp: "sign-up",
        updateEmail: "update-email",
        updatePhone: "update-phone",
    };
    Const.dailyGoal = {
        small: "small",
        medium: "medium",
        large: "large",
        extra: "extra-large",
    };
    Const.languageCode = {
        afrikaans: "af",
        arabic: "ar",
        bengali: "bn",
        bulgarian: "bg",
        catalan: "ca",
        czech: "cs",
        chinese: "zh",
        croatian: "hr",
        danish: "da",
        dutch: "nl",
        english: "en",
        estonian: "et",
        finnish: "fi",
        french: "fr",
        german: "de",
        greek: "el",
        hebrew: "he",
        hindi: "hi",
        hungarian: "hu",
        icelandic: "is",
        indonesian: "id",
        italian: "it",
        japanese: "ja",
        korean: "ko",
        lao: "lo",
        latvian: "lv",
        lithuanian: "lt",
        malay: "ms",
        marathi: "mr",
        nepali: "ne",
        norwegian: "no",
        persian: "fa",
        polish: "pl",
        portuguese: "pt",
        punjabi: "pa",
        romanian: "ro",
        russian: "ru",
        serbian: "sr",
        sinhala: "si",
        slovak: "sk",
        swahili: "sw",
        spanish: "es",
        swedish: "sv",
        tagalog: "tl",
        tamil: "ta",
        thai: "th",
        turkish: "tr",
        ukrainian: "uk",
        urdu: "ur",
        vietnamese: "vi",
    };
    Const.cefrLevels = ["a1", "a2", "b1", "b2", "c1", "c2"];
    Const.userPreferenceName = {
        dailyDigestNotification: "daily-digest-notification",
        newChatMessageNotification: "new-chat-message-notification",
    };
    Const.userActivityType = {
        bookScheduleSlot: "book-schedule-slot",
        cancelScheduleSlot: "cancel-schedule-slot",
        return: "return",
        sendChatMessage: "send-chat-message",
        signIn: "sign-in",
    };
    Const.chatMessageType = { text: "text", voice: "voice" };
})(Const || (Const = {}));
exports.default = Const;
